/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

/* eslint-disable no-underscore-dangle */
import { isEmpty } from 'modules/common/helpers/object';
import { dataHandler } from '@phg/advanced-querying-module';
import { decode } from 'html-entities';
/**
 * Generate query based on selected breakdown sub categories
 * @param {Array} subCategories
 * @returns
 */
export const generateQuery = (field, subCategories) => {
  if (isEmpty(subCategories)) return null;
  const categoryLabel = subCategories?.map((element) => {
    // Escape single quotes by replacing ' with \'
    const escapedValue = element.label.replace(/'/g, "\\'");
    // Enclose in quotes if it contains space
    if (escapedValue.includes(' ')) {
      return `'${escapedValue}'`;
    }
    return escapedValue;
  });
  //
  return categoryLabel?.map((element) => `${field} EQUAL ${element}`).join(' OR ');
};

/**
 * To get Hotel List and focus on values
 * @param {Boolean} isDemoUser - Whether current user is a demo user
 * @param {Object} payload - Payload of getting hotels list action
 * @returns
 */
export const getHotelGroupFocusOnValue = (payload, hotelList, hotelMappingSchema) => {
  const hotelGroupDropdownList =
    payload?.results
      ?.filter((a) => a?.hotelGroups?.hotelQuery)
      ?.map((data) => ({
        id: data?.hotelGroups?.hotelGroupName,
        label: data?.hotelGroups?.hotelGroupName,
        query: data?.hotelGroups?.hotelQuery,
        hotels: dataHandler(decode(data?.hotelGroups?.hotelQuery), hotelList, hotelMappingSchema),
      }))
      ?.sort(
        (element1, element2) =>
          element1?.label && element2?.label && element1?.label?.localeCompare(element2?.label)
      ) ?? [];
  //
  return hotelGroupDropdownList;
};
